import Vue from "vue"
import VueRouter from "vue-router"
import NProgress from "nprogress"
import { Message } from "element-ui"
import store from "@/store"
Vue.use(VueRouter)
// permission 访问所需权限	0游客 1普通用户	2管理员（帖子，评论，审核） 3博主 4审核员
// notPermission 不显示菜单的权限
// record 是否需要记录访问记录 true/false
// auth 是否缓存页面 true/false
// allScreen 是否全屏展示
// icon 图标
const routes = [{
	path: "/",
	name: "欢迎页",
	component: () => import("@/views/welcome"),
	meta: {
		record: true,
		auth: false,
		icon: "el-icon-user-solid"
	}
},
{
	path: "/user",
	component: () => import("@/views/user/Index"),
	name: "用户管理",
	meta: {
		permission: [888],
		record: true,
		auth: false,
		icon: "el-icon-user-solid"
	}
},
// {
// 	path: "/units",
// 	component: () => import("@/views/units/Index"),
// 	name: "单位管理",
// 	meta: {
// 		permission: [888],
// 		record: true,
// 		auth: false,
// 		icon: "el-icon-office-building"
// 	}
// },
{
	path: "/404",
	name: "404",
	component: () => import("@/views/404"),
	meta: {
		auth: false,
		allScreen: true
	}
},
{
	path: "/403",
	name: "权限不足",
	component: () => import("@/views/403"),
	meta: {
		auth: false,
		allScreen: true
	}
},
{
	path: "/login",
	name: "登录/注册",
	component: () => import("@/views/login"),
	meta: {
		auth: false,
		allScreen: true
	}
},
{
	path: "*",
	redirect: "/404",
	allScreen: true

},
// {
// 	path: "/products",
// 	component: () => import("@/views/products/Index"),
// 	name: "产品管理",
// 	meta: {
// 		permission: [888],
// 		record: true,
// 		auth: false,
// 		icon: "el-icon-s-goods"
// 	}
// },
{
	path: "/purchase",
	component: () => import("@/views/purchase/Index"),
	name: "买",
	meta: {
		permission: [888],
		record: true,
		auth: true,
		icon: "el-icon-s-finance"
	},
	children: [
		{
			path: "contract/:code?",
			name: "买货合同",
			component: () => import("@/views/purchase/contract/Index"),
			// props: route => ({ code: route.params.code }),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "paymentDoc/:code?",
			component: () => import("@/views/purchase/paymentDoc/Index"),
			name: "付款单",
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-s-finance"
			},
		}
	]
},
{
	path: "/sell",
	component: () => import("@/views/sell/Index"),
	name: "卖",
	meta: {
		permission: [888],
		record: true,
		auth: false,
		icon: "el-icon-s-finance"
	},
	children: [
		{
			path: "contract/:code?",
			name: "卖货合同",
			component: () => import("@/views/sell/contract/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "paymentDoc/:code?",
			component: () => import("@/views/sell/paymentDoc/Index"),
			name: "收款单",
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-s-finance"
			},
		}
	]
},
{
	path: "/temporaryContracts",
	component: () => import("@/views/contract/Index"),
	name: "临时合同",
	meta: {
		permission: [888],
		record: true,
		auth: true,
		icon: "el-icon-tickets"
	},
	children: [
		{
			path: "add",
			name: "新建合同",
			component: () => import("@/views/temporaryContracts/add/Index"),
			meta: {
				permission: [888],
				record: false,
				auth: false,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "temporary",
			name: "合同草稿管理",
			component: () => import("@/views/temporaryContracts/contract/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
	]
},
{
	path: "/profile",
	component: () => import("@/views/profile/Index"),
	name: "资料",
	meta: {
		permission: [888],
		record: true,
		auth: true,
		icon: "el-icon-s-order"
	},
	children: [
		{
			path: "client",
			name: "客户录入",
			component: () => import("@/views/profile/client/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "supplier",
			name: "供应商录入",
			component: () => import("@/views/profile/supplier/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "account",
			name: "斯亿卡账户录入",
			component: () => import("@/views/profile/account/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		}
	]
},
{
	path: "/financial", 
	component: () => import("@/views/financial/Index"),
	name: "往来对帐",
	meta: {
		permission: [888],
		record: true,
		auth: true,
		icon: "el-icon-s-finance"
	},
	children: [
		{
			path: "customers",
			name: "客户对账",
			component: () => import("@/views/financial/customers/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		},
		{
			path: "summary",
			name: "往来单位汇总",
			component: () => import("@/views/financial/summary/Index"),
			meta: {
				permission: [888],
				record: true,
				auth: true,
				icon: "el-icon-tickets"
			},
		}
	]
}]

const router = new VueRouter({
	routes,
	// mode: "history"
})

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	if (to.name) {
		document.title = to.name
	}

	if (to?.meta?.permission) {
		// 获取用户数据
		let { data } = await store.dispatch("user/getUser")
		if (data.id === 0) {
			router.push("/login")
			return next()
		}
		if (!to.meta?.permission?.some(item => item == data.type)) {
			Message.error("权限不足");
			console.log("权限不足");
			return next()
		}

	}
	NProgress.done()
	next()
})

export {
	router,
	routes
}